import React from "react";
import "../style/breve.css";

const EmBreve = () => {
  return (
    <div className="em-breve-container">
      <h1 className="em-breve-texto">EM BREVE</h1>
      <i class="fa-solid fa-hourglass-start"></i>
    </div>
  );
};

export default EmBreve;